import { FC, ReactNode } from 'react';
import { flexRender, Header, HeaderGroup } from '@tanstack/react-table';
import { FaIcon } from '../FaIcon';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { cn } from '../../utils';

type TableHeaderProps = {
  headerGroups: HeaderGroup<any>[];
};

const TableHeaderCell: FC<{
  className?: string;
  header: Header<any, unknown>;
  children?: ReactNode;
}> = ({ header, className, children }) => {
  return (
    <th
      className={cn('lf:whitespace-nowrap', className)}
      key={header.id}
      style={{
        minWidth: header.getSize() !== 0 ? header.getSize() : undefined,
      }}
    >
      {children}
    </th>
  );
};

export const TableHeader: FC<TableHeaderProps> = ({ headerGroups }) => {
  return (
    <thead className="l-table-head">
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            const metaClass = header.column.columnDef.meta?.headerClassName;

            if (header.isPlaceholder) {
              return (
                <TableHeaderCell
                  header={header}
                  key={header.id}
                  className={metaClass}
                />
              );
            }

            if (header.column.getCanSort()) {
              return (
                <TableHeaderCell
                  className={cn('l-table-head-sortable', metaClass)}
                  header={header}
                  key={header.id}
                >
                  <button onClick={header.column.getToggleSortingHandler()}>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
                    <FaIcon
                      icon={
                        header.column.getIsSorted() === 'asc'
                          ? faCaretUp
                          : faCaretDown
                      }
                      width={16}
                      height={16}
                      className={cn(
                        !header.column.getIsSorted() && 'lf:invisible',
                      )}
                    />
                  </button>
                </TableHeaderCell>
              );
            }

            return (
              <TableHeaderCell
                header={header}
                key={header.id}
                className={metaClass}
              >
                {flexRender(
                  header.column.columnDef.header,
                  header.getContext(),
                )}
              </TableHeaderCell>
            );
          })}
        </tr>
      ))}
    </thead>
  );
};
